import { AppShell, type NavEntry } from '@cyntox/common/AppShell';
import { useApp } from '../state/AppContext';

// The frame (sidebar, drawer, footer, version, help, links to the other apps)
// is shared by every Cyntox site. This is Inventory's menu: the week's counts
// first, then the reference data they are built on.

const NAV: NavEntry[] = [
  { to: '/dashboard', label: 'Dashboard', resource: 'counts' },
  { to: '/counts', label: 'Counts', resource: 'counts' },
  { to: '/setup/locations', label: 'Locations', resource: 'setup' },
  { to: '/setup/supplies', label: 'Supplies', resource: 'setup' },
  { to: '/setup/targets', label: 'Targets', resource: 'setup' },
];

export function Shell() {
  const { regionName } = useApp();

  return (
    <AppShell
      app="inventory"
      badge="INVENTORY"
      nav={NAV}
      version={__APP_VERSION__}
      helpLabel="How to use Inventory"
      noLocationLabel="No regions"
      allLocationsLabel="All regions"
      locationName={regionName}
    />
  );
}
